import { api } from "@/lib/api";

export const SyllabusAPI = {
  boards: () => api.get("/syllabus/boards").then((r) => r.data),
  list: (params) => api.get("/syllabus", { params }).then((r) => r.data),
  upload: (formData) =>
    api.post("/syllabus/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data),
  bulkUpload: (formData) =>
    api.post("/syllabus/bulk-upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data),
  remove: (id) => api.delete(`/syllabus/${id}`).then((r) => r.data),
  fileUrl: (fileId) => `/api/v1/syllabus/files/${fileId}`,
  // AI-extraction endpoints
  extractions: (params) => api.get("/syllabus/extractions", { params }).then((r) => r.data),
  extraction: (eid) => api.get(`/syllabus/extractions/${eid}`).then((r) => r.data),
  removeExtraction: (eid) => api.delete(`/syllabus/extractions/${eid}`).then((r) => r.data),
  suggestions: (params) => api.get("/syllabus/suggestions", { params }).then((r) => r.data),
};
